import { getInternalOrganizationMasterServiceAgreementApi } from '@/api/v1/organization/internal/getInternalOrganizationMasterServiceAgreementApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import {
  confirmInternalOrganizationMasterServiceAgreementApi,
  ConfirmInternalOrganizationMasterServiceAgreementPayloadType,
} from '@/api/v1/organization/internal/confirmInternalOrganizationMasterServiceAgreementApi';

export const getInternalOrganizationMasterServiceAgreement = async () => {
  try {
    const response = await getInternalOrganizationMasterServiceAgreementApi();

    return prepareResponse(response);
  } catch (error) {
    throwResponseError(error);
  }
};

export const confirmInternalOrganizationMasterServiceAgreement = async (
  payload: ConfirmInternalOrganizationMasterServiceAgreementPayloadType
) => {
  try {
    const response = await confirmInternalOrganizationMasterServiceAgreementApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
